import { LoggedUser, Related } from './LoggedUser'
import { LangType } from '../../content/enums/LangType'

export interface LoggedUserDTO {
  id: string
  name: string
  gender: number
  birthDate: string
  language: LangType
  dni: string
  cip: string
  sessionExpires: string
  related: Related[]
  permissions: string[]
  roles: string[]
}

export function toModel(d: LoggedUserDTO): LoggedUser {
  return new LoggedUser({
    id: d.id,
    name: d.name,
    gender: d.gender,
    birthDate: new Date(d.birthDate),
    language: d.language,
    dni: d.dni,
    cip: d.cip,
    sessionExpires: new Date(d.sessionExpires),
    related: d.related,
    permissions: d.permissions,
    roles: d.roles,
  })
}

export function fromModel(m: LoggedUser): LoggedUserDTO {
  return {
    id: m.id,
    name: m.name,
    gender: m.gender,
    birthDate: m.birthDate.toISOString(),
    language: m.language,
    dni: m.dni,
    cip: m.cip,
    sessionExpires: m.sessionExpires.toISOString(),
    related: m.related,
    permissions: m.permissions,
    roles: m.roles,
  }
}
